import styles from './BlockImage.module.css'

interface BlockImageProps {
  src: string
}

export default function BlockImage(props: BlockImageProps) {
  return <div className={styles.blockImage}><img src={props.src} alt="Body Part"/></div>
}